import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

type UseGetUsersByCompanyProps = {
  companyId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetEmployeesByCompany = ({
  companyId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetUsersByCompanyProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery(
    [
      ...UserKey.BY_COMPANY_PAGED(companyId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      usersRepo.getEmployeesByCompany(
        companyId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
